import { usePersistentState } from "./usePersistentState";

export const useFirebaseUser = () => useState("firebaseUser", () => null);

export const useCurrentCareDay = () => usePersistentState("currentCareDay", null);
export const useCurrentKioskCareDay = () => useState("currentKioskCareDay", () => null);
